<script setup lang="ts">
/**
 * Round "+" action button for mobile tab headers, used instead of the wide
 * "+ ADD" button where the title row has no room for it. `label` is the
 * descriptive per-entity string (e.g. "Add client") exposed as `aria-label`.
 */
defineProps<{ label: string }>()
defineEmits<{ click: [] }>()
</script>

<template>
  <button type="button" class="compact-add-btn" :aria-label="label" @click="$emit('click')">
    +
  </button>
</template>

<style scoped>
.compact-add-btn {
  appearance: none;
  background: transparent;
  border: 1px solid var(--color-tufte-border);
  border-radius: 50%;
  width: 1.75rem;
  height: 1.75rem;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  line-height: 1;
  padding: 0;
  color: var(--color-tufte-muted);
  cursor: pointer;
}

.compact-add-btn:hover,
.compact-add-btn:active {
  color: var(--color-tufte-text);
  border-color: var(--color-tufte-text);
}

.compact-add-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 1px color-mix(in srgb, var(--color-tufte-text) 40%, transparent);
}
</style>
